import '@cbhq/cds-web/globalStyles';

import { IntlProvider } from 'react-intl';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PortalProvider } from '@cbhq/cds-web/overlays/PortalProvider';
import { ThemeProvider } from '@cbhq/cds-web/system/ThemeProvider';

import { AppErrorBoundary } from ':fat/errors/AppErrorBoundary';
import { bugsnagStart } from ':fat/init/bugsnag';
import { initAnalytics } from ':fat/init/initAnalytics';
import { ErrorFallbackPage } from ':fat/pages/ErrorFallback';
import { RouterProviderWithContext } from ':fat/routing/RouterProviderWithContext';

import { TransactionProvider } from './TransactionContext';

// Initialize Analytics
initAnalytics();

// Initialize Bugsnag
bugsnagStart();

export type AppProps = {
  locale: string;
  messages?: Record<string, string>;
};

const queryClient = new QueryClient();

export function App({ locale, messages }: AppProps) {
  return (
    <ThemeProvider>
      <PortalProvider>
        <IntlProvider locale={locale} defaultLocale="en" messages={messages}>
          <AppErrorBoundary fallback={ErrorFallbackPage}>
            <QueryClientProvider client={queryClient}>
              <TransactionProvider>
                <RouterProviderWithContext />
              </TransactionProvider>
            </QueryClientProvider>
          </AppErrorBoundary>
        </IntlProvider>
      </PortalProvider>
    </ThemeProvider>
  );
}
